/**
 * Item service API
 *
 * Contact:
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaginationRequest } from './paginationRequest';


/**
 * List of order ids
 */
export interface PromocodePaginationRequest {
    id?: number;
    orderIds?: Array<number>;
    unitedOrderIds?: Array<number>;
    codes?: Array<string>;
    active?: boolean;
    maxUsagePerBuyer?: number;
    type?: PromocodePaginationRequest.TypeEnum;
    minOrderPrice?: number;
    maxDiscount?: number;
    discount?: number;
    percent?: number;
    hint?: string;
    usageNumber?: number;
    maxUsageNumber?: number;
    usedBudget?: number;
    budget?: number;
    ordersTotal?: number;
    lang?: PromocodePaginationRequest.LangEnum;
    startedAt?: Date;
    finishedAt?: Date;
    beforeDate?: Date;
    afterDate?: Date;
    page: PaginationRequest;
}
export namespace PromocodePaginationRequest {
    export type TypeEnum = 'ABSOLUTE' | 'PERCENT';
    export const TypeEnum = {
        ABSOLUTE: 'ABSOLUTE' as TypeEnum,
        PERCENT: 'PERCENT' as TypeEnum
    };
    export type LangEnum = 'RU' | 'EN' | 'HI' | 'FR' | 'AR' | 'KM' | 'ZH';
    export const LangEnum = {
        RU: 'RU' as LangEnum,
        EN: 'EN' as LangEnum,
        HI: 'HI' as LangEnum,
        FR: 'FR' as LangEnum,
        AR: 'AR' as LangEnum,
        KM: 'KM' as LangEnum,
        ZH: 'ZH' as LangEnum
    };
}


